<template>
  <div class="map-data">
    <!-- <div class="font20" @click="toDetail({name,code})" style="cursor:pointer;">{{name?name:code}}</div> -->
    <el-table :data="table" :max-height="tableHeight" stripe v-loading="loading" style="width: 100%">
       <el-table-column
      type="index"
      width="50"/>
      <el-table-column prop="user" label="企业名称" align="center"></el-table-column>
      <el-table-column prop="card" label="所属省份" align="center"></el-table-column>
      <el-table-column prop="num" label="所属城市" align="center"></el-table-column>
      <el-table-column prop="litter" label="车辆数" align="center"></el-table-column>
      <el-table-column prop="mount" label="中国石油油站停靠次数"  width="160" align="center"></el-table-column>
      <el-table-column prop="etpref" label="其他油站停靠次数"  width="140" align="center"></el-table-column>
      <el-table-column prop="ommuse" label="运营公里数" align="center"></el-table-column>
      <el-table-column
      label="操作项"
       align="center"
      >
      <template slot-scope="scope">
        <el-button
          size="mini"
          type="primary"
         >车辆详情</el-button>
      </template>
    </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    dataAll: {
      type: [Array, Object]
    },
    toDetail: {
      type: Function,
      default: () => {}
    },
    name: {
      type: String,
      default: '合计'
    },
    code: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      table: []
    }
  },
  mounted() {
    if (this.dataAll) {
      this.table = [...this.initData(this.dataAll)]
    }
  },
  watch: {
    dataAll: function(value, oldValue) {
      if (value) {
        this.table = [...this.initData(value)]
      }
    }
  },
  methods: {
    initData(data) {
      let all = {}
      let user = {}
      let comp = {}
      all.user = data.toatlUser
      user.user = data.peopleUser
      comp.user = data.companyUser

      all.card = data.toatlCard
      user.card = data.peopleCard
      comp.card = data.companyCard

      all.num = data.toatlNumber //个人消费笔数
      user.num = data.peopleNumber //企业消笔数
      comp.num = data.companyNumber //总共消费笔数

      user.litter = data.peoplelitter //个人消费升数
      comp.litter = data.companlitter //企业消升数
      all.litter = data.toatllitter //总共消费升数

      user.mount = data.peopleAmount //个人消费金额
      comp.mount = data.companAmount //企业消金额
      all.mount = data.toatlAmount //总共消费金额

      user.etpref = data.peopleGetpref //个人产生优惠额 返利
      comp.etpref = data.companGetpref //企业产生优惠额
      all.etpref = data.toatlGetpref //总共产生优惠额

      user.ommuse = data.peopleGetprefCommuse //个人产生优惠加油额 返利消费
      comp.ommuse = data.companGetprefCommuse //企业产生优加油惠额
      all.ommuse = data.toatlGetprefCommuse //总共产生优惠加油额

      user.echarge = data.peopleRecharge //个人充值金额
      comp.echarge = data.companRecharge //企业充值金额
      all.echarge = data.toatlRecharge //中共充值金额
      return [all, user, comp]
    }
  }
}
</script>